module.exports = __webpack_public_path__ + "img/plus-blue.5fe116aa.svg";